import { Flex } from '@brightdrop/bd-ui';
import { useFeatureFlags } from '@brightdrop/feature-flags-client';

import { useTranslation } from 'react-i18next';
import ConnectedByOnStarTextSvg from '~/assets/icons/new/ConnectedByOnStarText.svg?react';
import { ONSTAR_FLEET_INTELLIGENCE_REBRAND_FLAG } from '~/common/models/featureFlags.model';
import useOnStarContentBannerStyles from './OnStarContentBanner.styles';

/**
 * OnStar ribbon on viewports below lg (mobile/tablet and native app WebView).
 * Shown below the global header in browser; at the top of main content in WebView.
 * Scrolls with page content (not fixed).
 */
const OnStarContentBanner = (): JSX.Element | null => {
  const { getFlag } = useFeatureFlags();
  const { classes } = useOnStarContentBannerStyles();
  const { t } = useTranslation();
  const isOnStarIntelligenceRebrandEnabled = Boolean(
    getFlag(ONSTAR_FLEET_INTELLIGENCE_REBRAND_FLAG)
  );

  if (isOnStarIntelligenceRebrandEnabled) {
    return null;
  }

  const ariaLabel = t('common:onStarRibbon.connectedByOnStarAriaLabel');

  return (
    <Flex className={classes.root} dataTestId="onstar-content-banner">
      <ConnectedByOnStarTextSvg
        role="img"
        aria-label={ariaLabel}
        data-testid="onstar-content-banner-label"
      />
    </Flex>
  );
};

export default OnStarContentBanner;
